import methodFieldDetailsDrawer from './MethodFieldDetailsDrawer.vue';

export default {
	methodFieldDetailsDrawer,
};
